import { useState, useEffect } from 'react';
import { SplitValue } from 'modules/workflows';
import { SplitValidation } from './types';

export const useSplitValidation = (splitValues: SplitValue[]) => {
  const [splitValidation, setSplitValidation] = useState<SplitValidation>({});
  const [isValid, setIsValid] = useState(true);
  useEffect(() => {
    const validation = splitValues.reduce((acc: SplitValidation, curr: SplitValue) => {
      if (acc[curr.value]) return acc; // if we already have key for that value, skip it.
      if (!curr.value) return { ...acc, ...{ [curr.value]: true } }; // if there's no value is valid
      const count = splitValues.filter((x) => x.value === curr.value).length;
      return { ...acc, ...{ [curr.value]: count <= 1 } };
    }, {} as SplitValidation);
    const valid = Object.values(validation).every((x) => x);
    setIsValid(valid);
    setSplitValidation(validation);
  }, [splitValues]);
  return { splitValidation, isValid };
};
